import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconShareStyle0 = gravityIconIndividualCss;

const GravityIconShare = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'bebc692fb96a191aa314bba19417d42631a5ff0a', color: this.color, size: this.size }, h("svg", { key: '06785e7e0f1b0514b391d40d420b516c89fe61b8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '402b50e63a5356f50a8ab01a1814e2fd6bc6d9c0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 13.5a2.5 2.5 0 0 0-1.93.93l-5.61-3a3.13 3.13 0 0 0 0-.44c.01-.15.01-.3 0-.45l5.62-3A2.49 2.49 0 1 0 13.5 6a1.116 1.116 0 0 0 0 .19l-5.76 3a2.5 2.5 0 1 0 0 3.54l5.76 3.06a1.005 1.005 0 0 0 0 .17A2.5 2.5 0 1 0 16 13.5Z", fill: "currentColor" }))));
    }
};
GravityIconShare.style = GravityIconShareStyle0;

export { GravityIconShare as gravity_icon_share };

//# sourceMappingURL=gravity-icon-share.entry.js.map